import { onboardingEnTranslations } from './onboarding.en';
import { onboardingHeTranslations } from './onboarding.he';

export const onboardingTranslations = {
  en: onboardingEnTranslations,
  he: onboardingHeTranslations,
} as const;
